import * as Sentry from "@sentry/react";

const isDevelopment = process.env.NODE_ENV === "development";

class ErrorLoggingService {
  static captureException(error: unknown, context?: string) {
    if (isDevelopment) {
      console.error(context ? `${context}:` : "Error:", error);
      return;
    }

    Sentry.captureException(error, context ? { tags: { context } } : undefined);
  }
}

export default ErrorLoggingService;
